import { Icon20Stars, Icon20WriteOutline, Icon28DocumentOutline, Icon28SearchStarsOutline } from '@vkontakte/icons';
import { Spacing, Text } from '@vkontakte/vkui';
import helperImage from 'img/aiSetHelper/helper.png';
import helperImageDark from 'img/aiSetHelper/helperDark.png';
import React, { type ReactElement, memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { Icon28PicturePenOultine } from 'reactApp/ui/VKUIIcons';

import styles from './AiSetFakedoorModal.css';

type variants = 'c' | 'd';

export interface AiSetProps {
    onClose: () => void;
    onClick: () => void;
    onShow: () => void;
    onDismiss: () => void;
    variant: variants;
}

interface TemplateArgs {
    title: string;
    text: string | ReactElement;
}

const PROPS_MAP: Record<variants, TemplateArgs> = {
    c: {
        title: 'Нейросеть в Облаке — сохранит время и силы',
        text: (
            <div className={styles.items}>
                <div className={styles.item}>
                    <Icon28DocumentOutline width={20} height={20} />
                    <span>Перескажет документы, когда нет&nbsp;времени разбираться в&nbsp;чём‑то сложном</span>
                </div>
                <div className={styles.item}>
                    <Icon28SearchStarsOutline width={20} height={20} />
                    <span>Удалит фон&nbsp;фотографии и&nbsp;оставит выбранные объекты</span>
                </div>
                <div className={styles.item}>
                    <Icon28PicturePenOultine width={20} height={20} />
                    <span>Добавит водяной знак, чтобы&nbsp;никто не&nbsp;присвоил ваш&nbsp;контент</span>
                </div>
            </div>
        ),
    },
    d: {
        title: 'Нейросеть в Облаке и Почте освободит время',
        text: (
            <div className={styles.items}>
                <div className={styles.item}>
                    <Icon28SearchStarsOutline width={20} height={20} />
                    <span>Соберёт важные письма и&nbsp;перескажет&nbsp;их</span>
                </div>
                <div className={styles.item}>
                    <Icon20WriteOutline width={20} height={20} />
                    <span>Напишет&nbsp;письмо&nbsp;за&nbsp;вас&nbsp;или&nbsp;изменит&nbsp;его&nbsp;стиль</span>
                </div>
                <div className={styles.item}>
                    <Icon28DocumentOutline width={20} height={20} />
                    <span>Передаст суть документов из&nbsp;Облака</span>
                </div>
                <div className={styles.item}>
                    <Icon28PicturePenOultine width={20} height={20} />
                    <span>Удалит фон&nbsp;с&nbsp;фото или&nbsp;добавит водяной знак</span>
                </div>
                <div className={styles.item}>
                    <Icon20Stars width={20} height={20} />
                    <span>Подключит чат-бота: он&nbsp;ответит&nbsp;на&nbsp;любой вопрос&nbsp;и&nbsp;подхватит мелкие дела</span>
                </div>
            </div>
        ),
    },
};

export const AiSetFakedoorModal = memo<AiSetProps>(({ variant, onShow, onClick, onClose, onDismiss }) => {
    useEffect(onShow, []);

    const isDarkTheme = useSelector(isCurrentDarkTheme);

    const { title, text } = PROPS_MAP[variant];

    const content = (
        <>
            <Spacing size={12} />
            <Text className={styles.text}>{text}</Text>
            <Spacing size={24} />
        </>
    );

    return (
        <WhatsNewDialog
            closeIconClassName={styles.closeIcon}
            primaryButtonText="Попробовать за 1 ₽"
            title={title}
            imageUrl={isDarkTheme ? helperImageDark : helperImage}
            content={content}
            dialogSize="small"
            buttonTheme="vk"
            onClick={onClick}
            onClose={onClose}
            onDismiss={onDismiss}
            closeAfterClick
        />
    );
});

AiSetFakedoorModal.displayName = 'AiSetFakedoorModal';
